import { DlfMatcher } from "../../models/matchers/DlfMatcher";
import { MatcherFactory } from "../../models/matchers/factory/MatcherFactory";
import { FieldMatcherEditorChildProps } from "../dlfEditing/FieldMatcherEditor";
import { AdvancedTooltip } from "../tooltips/AdvancedTooltip";
import { DlfTypeLabel } from "./DlfTypeLabel";
import { Label } from "./Label";

export { DlfMatcherLabel };

type Props = FieldMatcherEditorChildProps<DlfMatcher> & { label: string };
const DlfMatcherLabel = (props: Props) => (
  <AdvancedTooltip tooltipText={props.labelTooltip}>
    {(tProps) => (
      <>
        {props.changedMatcherType && (
          <DlfTypeLabel
            onClick={props.onClickLabel}
            color={props.labelColor}
            backgroundColor={props.labelBgColor}
            {...tProps}
            onMatcherChange={(type) =>
              props.changedMatcherType!(
                MatcherFactory.changeDlfMatcher(
                  props.matcher,
                  type,
                  props.docFieldConfig.threshold,
                ),
              )
            }
            discriminator={props.matcher.getDiscriminator()}
          >
            {props.label}
          </DlfTypeLabel>
        )}
        {!props.changedMatcherType && (
          <Label
            onClick={props.onClickLabel}
            color={props.labelColor}
            backgroundColor={props.labelBgColor}
            {...tProps}
          >
            {props.label}
          </Label>
        )}
      </>
    )}
  </AdvancedTooltip>
);
